import axiosInstance from './axiosInstance';

export interface ClarityResponse {
  clarityId: string;
}

export async function getClarityIdAPI(tenantName: string): Promise<string> {
  const response = await axiosInstance.get<ClarityResponse>(`/Auth/GetClarityId`, {
    params: { tenantName },
  });
  return response.data.clarityId;
}
